import { NSARouterMakerResult } from "namirasoft-account-react";
import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { TelegramSenderEntities } from "../TelegramSenderEntities";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";

export interface ProviderListPageProps extends NSARouterMakerResult, TelegramSenderRouterProps
{ }

function ProviderListPage(props: ProviderListPageProps)
{
	debugger;
	return (
		<TelegramSenderLayout {...props}
			action={{
				description: " This section displays all Telegram providers you have created with their basic information.",
			}}
			pages={{
				entity: TelegramSenderEntities.provider(props),
				list: {
					ui: {}
				}
			}}>
			<></>
		</TelegramSenderLayout>
	);
}

export default ProviderListPage;